import { createSlice } from '@reduxjs/toolkit';

import { apiReducerBuilder } from 'utils';

import { Globals, WPMenu } from 'models';

import { getGlobals, getMenu } from './actions';

interface Settings {
	globals: Globals;
	status: string;
	menu: WPMenu;
}

const settingsSlice = createSlice({
	name: 'settings',
	initialState: { globals: { languages: {} }, menu: {} as WPMenu } as Settings,
	reducers: {},
	extraReducers: (builder) => {
		apiReducerBuilder(builder, getGlobals, (state, action) => {
			const { payload, meta } = action;
			state.status = meta.requestStatus;
			state.globals = payload;
		});

		apiReducerBuilder(builder, getMenu, (state, action) => {
			const { payload, meta } = action;

			state.status = meta.requestStatus;
			state.menu = payload;
		});
	},
});

export default settingsSlice.reducer;
